<template>
  <section class="settings-section section-block">
    <SectionTitle
      cyBtn="edit-time-parameter"
      :title="displayData.title"
      :btn="displayData.btn.edit"
      @edit="modal.edit = true"
    />
    <div>
      <BaseElForm label-position="left" label-width="280px">
        <BaseElFormItem class="settings-item">
          <template slot="label">
            <div class="flex items-center" style="gap: 8px">
              <p>{{ displayData.minReservationInterval.label }}</p>
              <TipInfo :size="16" width="200">
                <p>{{ displayData.minReservationInterval.tooltip }}</p>
              </TipInfo>：
            </div>
          </template>
          <span class="content">{{ displayData.minReservationInterval.value }}</span>
        </BaseElFormItem>

        <BaseElFormItem class="settings-item">
          <template slot="label">
            <div class="flex items-center" style="gap: 8px">
              <p>{{ displayData.maxReservationInterval.label }}</p>
              <TipInfo :size="16" width="200">
                <p>{{ displayData.maxReservationInterval.tooltip }}</p>
              </TipInfo>：
            </div>
          </template>
          <span class="content">{{ displayData.maxReservationInterval.value }}</span>
        </BaseElFormItem>

        <BaseElFormItem class="settings-item">
          <template slot="label">
            <div class="flex items-center" style="gap: 8px">
              <p>{{ displayData.cancelInterval.label }}</p>
              <TipInfo :size="16" width="200">
                <p>{{ displayData.cancelInterval.tooltip }}</p>
              </TipInfo>：
            </div>
          </template>
          <span class="content">{{ displayData.cancelInterval.value }}</span>
        </BaseElFormItem>
        <BaseElFormItem class="settings-item" :label="displayData.enableCancelReasonCollection.label">
          <span class="content">{{ displayData.enableCancelReasonCollection.value }}</span>
        </BaseElFormItem>
        <BaseElFormItem class="settings-item" :label="displayData.enableClientCustomTimeSlots.label">
          <span class="content">{{ displayData.enableClientCustomTimeSlots.value }}</span>
        </BaseElFormItem>
      </BaseElForm>
    </div>

    <EditReservationClientPeriodSettingsModal
      v-if="modal.edit"
      data-testid="edit-reservation-client-period-settings-modal"
      :configData="configData"
      @close="modal.edit = false"
      @refresh="$emit('refresh')"
    />
  </section>
</template>

<script>
import { defineComponent, reactive, computed } from 'vue'
import EditReservationClientPeriodSettingsModal from './EditReservationClientPeriodSettingsModal.vue'
import TipInfo from '@/components/TipInfo.vue'
import { get, isNull, isUndefined } from 'lodash'
import { i18n } from '@/plugins/i18n/i18n'

export default defineComponent({
  name: 'ReservationClientPeriodSettings',
  components: {
    EditReservationClientPeriodSettingsModal,
    TipInfo,
  },
  props: {
    configData: {
      type: Object,
      default: () => ({}),
    },
  },
  setup (props, { emit }) {
    const modal = reactive({
      edit: false,
    })

    const displayValue = (value) => {
      if (isNull() || isUndefined(value)) {
        return i18n.t('common.notSetupYet.text')
      }
      if (value === -1) {
        return i18n.t('common.unlimited.text')
      }
      if (value < 60) {
        return `${value} ${i18n.t('common.timeUnit.minute')}`
      } else if (value >= 60 && value < 1440) {
        return `${value / 60} ${i18n.t('common.timeUnit.hour')}`
      } else if (value >= 1440) {
        return `${value / 1440} ${i18n.t('common.timeUnit.day')}`
      }
    }

    const displayData = computed(() => {
      const data = {
        title: i18n.t('reservationClientPeriodSettings.title'),
        minReservationInterval: {
          label: i18n.t('reservationClientPeriodSettings.minReservationInterval.title'),
          tooltip: i18n.t('reservationBasicSettings.minReservationInterval.tooltip'),
          value: displayValue(get(props.configData, 'minReservationInterval')),
        },
        maxReservationInterval: {
          label: i18n.t('reservationClientPeriodSettings.maxReservationInterval.title'),
          tooltip: i18n.t('reservationBasicSettings.maxReservationInterval.tooltip'),
          value: displayValue(get(props.configData, 'maxReservationInterval')),
        },
        cancelInterval: {
          label: i18n.t('reservationClientPeriodSettings.cancelInterval.title'),
          tooltip: i18n.t('reservationBasicSettings.cancelInterval.tooltip'),
          value: displayValue(get(props.configData, 'cancelInterval')),
        },
        enableCancelReasonCollection: {
          label: `${i18n.t('reservationClientPeriodSettings.enableCancelReasonCollection.title')}：`,
          value: get(props.configData, 'enableCancelReasonCollection') ? i18n.t('common.open.text') : i18n.t('common.close.text'),
        },
        enableClientCustomTimeSlots: {
          label: `${i18n.t('reservationClientPeriodSettings.enableClientCustomTimeSlots.title')}：`,
          value: get(props.configData, 'enableClientCustomTimeSlots') ? i18n.t('common.open.text') : i18n.t('common.close.text'),
        },
        btn: {
          edit: i18n.t('common.button.edit.text'),
        },
      }

      return data
    })
    return {
      modal,
      displayData,
    }
  },
})
</script>

<style lang="postcss" scoped></style>
